export const servicesData = [
  {
    id: 'interactive-panels',
    title: 'Interactive Flat Panels',
    description: 'Transform your classroom with cutting-edge interactive displays. Multi-touch technology, 4K UHD resolution, and wireless collaboration for immersive learning experiences.',
    icon: 'Monitor',
    features: ['65" to 110" Screen Sizes', '20/40/50 Multi-Touch', 'Android & Windows Support', 'Google EDLA Certified']
  },
  {
    id: 'education-cameras',
    title: 'Education Cameras',
    description: 'Professional-grade cameras designed for educational environments. Perfect for lecture recording, video conferencing, and remote learning solutions.',
    icon: 'Video',
    features: ['4K Recording', 'Auto-Tracking', 'PTZ Control', 'Live Streaming']
  },
  {
    id: 'smart-classroom',
    title: 'Smart Classroom Setup',
    description: 'Complete digital classroom solutions integrating interactive panels, cameras, and collaboration tools for modern education.',
    icon: 'GraduationCap',
    features: ['Full Installation', 'Teacher Training', 'Technical Support', 'Custom Configuration']
  },
  {
    id: 'collaboration-tools',
    title: 'Collaboration Software',
    description: 'Advanced annotation tools, screen sharing, and e-whiteboard software to enhance interactive learning and engagement.',
    icon: 'Users',
    features: ['Digital Whiteboard', 'Screen Sharing', 'Remote Collaboration', 'Educational Apps']
  },
  {
    id: 'video-conferencing',
    title: 'Video Conferencing Solutions',
    description: 'Enterprise-grade video conferencing systems for hybrid learning, remote teaching, and virtual classrooms.',
    icon: 'Presentation',
    features: ['HD Video Quality', 'Wireless Casting', 'Multi-Device Support', 'Cloud Recording']
  },
  {
    id: 'support-maintenance',
    title: 'Support & Maintenance',
    description: 'Comprehensive after-sales support, warranty services, and regular maintenance to keep your equipment running smoothly.',
    icon: 'Headphones',
    features: ['On-Site Support', 'Remote Assistance', 'Annual Maintenance', 'Software Updates']
  }
];